<template>
  <el-dialog :title="id ? '编辑价格' : '新增价格'" :visible.sync="dialogFormVisible" width="600px">
    <el-form
      ref="dataForm"
      :rules="rules"
      :model="temp"
      label-position="left"
      label-width="160px"
      style="margin: 0 30px"
    >
      <el-form-item label="项目名称" prop="project_id">
        <el-select
          v-model="temp.project_id"
          filterable
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="handleProjectChange"
        >
          <el-option
            v-for="item in project_options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="套餐名称" prop="package_name">
        <el-input v-model="temp.package_name" placeholder="请填写名称" />
      </el-form-item>
      <el-form-item label="平台" prop="platform">
        <el-select
          v-model="temp.platform"
          filterable
          placeholder="请选择所属平台"
          style="width: 100%"
        >
          <el-option
            v-for="item in platform_options"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市" prop="city">
        <CitySelect
          customStyle="width: 100%"
          v-model="temp.city"
          @onChange="(e) => (temp.city = e)"
        />
      </el-form-item>
      <el-form-item label="满团人数" prop="full_group_num">
        <el-input v-model="temp.full_group_num" placeholder="请输入满团人数" />
      </el-form-item>
      <el-form-item label="成人淡季价格(单人)" prop="off_season_per_price">
        <el-input type="number" v-model="temp.off_season_per_price" placeholder="请输入">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
      <el-form-item label="老人淡季价格(单人)" prop="old_off_season_per_price">
        <el-input type="number" v-model="temp.old_off_season_per_price" placeholder="请输入">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
      <el-form-item label="儿童淡季价格(单人)" prop="child_off_season_per_price">
        <el-input type="number" v-model="temp.child_off_season_per_price" placeholder="请输入">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
      <el-form-item label="成人旺季价格(单人)" prop="peak_season_per_price">
        <el-input type="number" v-model="temp.peak_season_per_price" placeholder="请输入">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
      <el-form-item label="老人旺季价格(单人)" prop="old_peak_season_per_price">
        <el-input type="number" v-model="temp.old_peak_season_per_price" placeholder="请输入">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
      <el-form-item label="儿童旺季价格(单人)" prop="child_peak_season_per_price">
        <el-input type="number" v-model="temp.child_peak_season_per_price" placeholder="请输入">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
      <el-form-item label="淡季价格(一口价)" prop="off_season_package_price">
        <el-input type="number" v-model="temp.off_season_package_price" placeholder="请输入">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
      <el-form-item label="旺季价格(一口价)" prop="peak_season_package_price">
        <el-input type="number" v-model="temp.peak_season_package_price" placeholder="请输入">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail, add, edit } from '@/api/productsPrice'
import { getList as getProjectList } from '@/api/projects'
import { PLATFORM_OPTIONS } from '@/utils/platform'
import CitySelect from '@/components/CitySelect'
const rule = [{ required: true, message: '必填项不能为空' }]

const getDefaultTemp = () => {
  return {
    project_id: '',
    package_name: '',
    platform: '',
    full_group_num: '',
    off_season_per_price: '',
    peak_season_per_price: '',
    old_off_season_per_price: '',
    old_peak_season_per_price: '',
    child_off_season_per_price: '',
    child_peak_season_per_price: '',
    off_season_package_price: '',
    peak_season_package_price: '',
    city: ''
  }
}

export default {
  name: 'ProductsPriceEdit',
  components: {
    CitySelect
  },
  data() {
    return {
      dialogFormVisible: false,
      id: '',
      temp: getDefaultTemp(),
      rules: {
        package_name: rule,
        platform: rule,
        city: rule
      },
      type: '',
      project_options: [],
      platform_options: PLATFORM_OPTIONS
    }
  },
  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
  },
  methods: {
    handleProjectChange(val) {
      const project = this.project_options.find((item) => item.id === val)
      if (project) {
        this.temp.city = project.city
      }
    },
    // 添加
    handleCreate() {
      this.type = 'add'
      this.id = ''
      this.temp = getDefaultTemp()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    _getDetail(id) {
      getDetail(id).then((res) => {
        this.id = id
        const data = res.data
        // Compatible with both object and ID for project field if API varies
        const projectId = typeof data.project === 'object' ? data.project.id : data.project
        this.temp = {
          ...this.temp,
          ...data,
          project_id: projectId
        }
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      })
    },
    // 编辑
    handleEdit(id, type) {
      this.type = type
      this.temp = getDefaultTemp()
      this._getDetail(id)
    },
    /**
     * @description: 复制
     * @return {*}
     */
    handleCopy(id, type) {
      this.type = type
      this._getDetail(id)
    },
    // 保存
    saveData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const d = JSON.parse(JSON.stringify(this.temp))
          // Ensure project_id is number if needed, though Select usually returns value type of option
          const p = this.type === 'edit' ? edit(this.id, d) : add(d)
          p.then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
          })
        }
      })
    }
  }
}
</script>
